module.exports = __webpack_public_path__ + "369a0c55e99d667f0feb7ed606a1e57b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/eric.png
// module id = 784
// module chunks = 0